import { Box } from "@mui/system";
import React from "react";

const DialogContentParagraph = ({ children }: { children: React.ReactNode }) => <Box sx={{ margin: "0.5rem 0 0 0" }}>{children}</Box>
export default DialogContentParagraph;